var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker20Dp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "speaker_20dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 217,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "0220\\u66F4\\u65B0--modal-view-\\u786E\\u5B9A\\u7248\\u672C",
    transform: "translate(-58.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(42.000000, 339.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "speaker_20dp",
    transform: "translate(16.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75,10 C14.9,10 15.825,9.06666667 15.825,7.91666667 C15.825,6.76666667 14.9,5.83333333 13.75,5.83333333 C12.6,5.83333333 11.6666667,6.76666667 11.6666667,7.91666667 C11.6666667,9.06666667 12.6,10 13.75,10 Z M7.5,9.16666667 C8.88333333,9.16666667 9.99166667,8.05 9.99166667,6.66666667 C9.99166667,5.28333333 8.88333333,4.16666667 7.5,4.16666667 C6.11666667,4.16666667 5,5.28333333 5,6.66666667 C5,8.05 6.11666667,9.16666667 7.5,9.16666667 Z M13.75,11.6666667 C12.225,11.6666667 9.16666667,12.4333333 9.16666667,13.9583333 L9.16666667,15.8333333 L18.3333333,15.8333333 L18.3333333,13.9583333 C18.3333333,12.4333333 15.275,11.6666667 13.75,11.6666667 Z M7.5,10.8333333 C5.55833333,10.8333333 1.66666667,11.8083333 1.66666667,13.75 L1.66666667,15.8333333 L7.5,15.8333333 L7.5,13.9583333 C7.5,13.25 7.775,12.0083333 9.475,11.0666667 C8.75,10.9166667 8.05,10.8333333 7.5,10.8333333 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker20Dp);
export default __webpack_public_path__ + "static/media/speaker_20dp.8103916ae4d57d8708c4fc9d16eba118.svg";
export { ForwardRef as ReactComponent };